import { baseMutations, baseActions } from '../functions'

export default {
  namespaced: true,
  state: {
    items: [],
    title: 'Métricas Operacionais',
    name: 'Métricas Operacionais',
    loading: true,

    menu: {
      title: 'Operacional',
      icon: { key: 'tools', custom: true }
    },

    actions: {
      component: 'Cards.AnalisesMelhorias',
      props: {}
    }
  },
  mutations: Object.assign({}, baseMutations, {

  }),

  actions: Object.assign({}, baseActions, {

  })
}
